var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"coverContainer",staticClass:"image-cover-container"},[_c('img',{staticClass:"squircle cover-image",style:({
    'width': (_vm.coverSize + "px"),
    'height': (_vm.coverSize + "px"),
  }),attrs:{"src":_vm.imageSrc},on:{"error":function($event){_vm.forceFallback = true}}})])}
var staticRenderFns = []

export { render, staticRenderFns }